// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 28) return "static/js/63e5e299d5014ba2453a.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"83b859bc4181841cd4c0","151":"54a1b7e96bcffe124449","152":"193423c9ce4b3313cef0"}[chunkId] + ".chunk.js";
};